import type { ReactNode } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export interface PageHeaderProps {
  eyebrow?: string
  title: string
  subtitle?: string
  badge?: ReactNode
  actions?: ReactNode
  className?: string
}

export function PageHeader({ eyebrow, title, subtitle, badge, actions, className }: PageHeaderProps) {
  return (
    <header className={mergeClassNames('master-heading', className)}>
      <div>
        {eyebrow ? <span>{eyebrow}</span> : null}
        <div className="master-heading__title">
          <h2>{title}</h2>
          {badge}
        </div>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {actions ? <div className="master-heading__actions">{actions}</div> : null}
    </header>
  )
}
